module.exports = __webpack_public_path__ + "static/mercury-starship-lockup-a4258ab2fb0161b4f2f8b40e15230195.png";